import { QueryKeys } from "@lib/enums/QueryKeys";
import { ClientFetchService } from "@lib/helpers/clientFetchService";
import { useApi } from "@lib/helpers/useApi";
import type { YotpoResponseObject } from "./types";
import { normalizeProductReviews } from "../helpers";
import { useLocale } from "next-intl";
import { getYotpoParams } from "./yotpoConfig";

export const getYotpoReviews = async ({
    yotpoAppId,
    articleNumber,
}: {
    yotpoAppId: string;
    articleNumber: string;
}) => {
    return await ClientFetchService.get<YotpoResponseObject>(
        `https://api.yotpo.com/v1/widget/${yotpoAppId}/products/${articleNumber}/reviews`
    ).then((data) => {
        return normalizeProductReviews(data.response);
    });
};

export const useProductReviews = (articleNumber: string) => {
    const locale = useLocale();
    const locales = process.env.NEXT_PUBLIC_LOCALES?.split(",") ?? [];
    const { yotpoAppId, yotpoEnabled } = getYotpoParams(locales, locale);

    const { data: productReviews } = useApi.useAsync(
        [QueryKeys.getYotpoReviews, articleNumber],
        () => getYotpoReviews({ yotpoAppId: yotpoAppId!, articleNumber }),
        { enabled: yotpoEnabled && !!yotpoAppId }
    );

    return productReviews;
};
